import { jsx, jsxs } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { IconCircleSpinnerSolid } from '@circlefin/euclid-icons/common';
import classNames from 'classnames';
import ButtonTooltip from '../Button.Tooltip.es.js';

const Button = /*#__PURE__*/ forwardRef(({ variant, intent, size = 'base', iconOnly = false, className, type = 'button', children, loading, disabled, onClick, label, ...props }, ref)=>{
    const classes = classNames('cb-button', size, variant, intent, className, {
        loading,
        'icon-only': iconOnly
    });
    return jsx(ButtonTooltip, {
        iconOnly: iconOnly,
        label: label,
        variant: variant,
        children: jsxs("button", {
            ref: ref,
            "aria-label": label,
            className: classes,
            disabled: loading || disabled,
            onClick: !disabled ? onClick : undefined,
            type: type,
            ...props,
            children: [
                loading && jsx("div", {
                    className: "spinner",
                    children: jsx(IconCircleSpinnerSolid, {
                        className: "animate-spin",
                        size: 18
                    })
                }),
                jsx("span", {
                    children: children
                })
            ]
        })
    });
});
Button.displayName = 'Button';

export { Button as default };
//# sourceMappingURL=Button.es.js.map
